import React from 'react'
import { Route, IndexRedirect, IndexRoute } from 'react-router'
import { requireAuth, requirePremium } from 'shared/auth'

import NotFoundPage from 'components/layout/NotFoundPage'

// landing
import Landing from 'components/landing/Landing'

// home
import ActivityFeed from 'components/home/ActivityFeed'
import Dashboard from 'components/home/Dashboard'

// premium
import CheckoutPage from 'components/premium/CheckoutPage'
import ReceiptPage from 'components/premium/ReceiptPage'
import CouponPage from 'components/premium/CouponPage'
import SubscriptionSettings from 'components/premium/SubscriptionSettings'

// routes
import RoutePrintPage from 'components/routes/print/RoutePrintPage'
import RouteSearchPage from 'components/routes/search/RouteSearchPage'
import MyRoutesPage from 'components/routes/myRoutes/MyRoutesPage'
import MyBookmarksPage from 'components/routes/myRoutes/MyBookmarksPage'
import MyCoursesPage from 'components/routes/myRoutes/MyCoursesPage'

// workouts
import LifetimeStatsPage from 'components/workouts/dashboard/lifetime/LifetimeStatsPage'
import LogWorkoutPage from 'components/workouts/create/LogWorkoutPage'
import CopyWorkoutPage from 'components/workouts/copy/CopyWorkoutPage'
import EditWorkoutPage from 'components/workouts/edit/EditWorkoutPage'

// friends
import MyFriends from 'components/friends/MyFriends'
import InviteFriends from 'components/friends/InviteFriends'
import FindFriends from 'components/friends/FindFriends'

// goals
import PersonalGoalsPage from 'components/goals/view/PersonalGoalsPage'
import CreateGoalPage from 'components/goals/create/CreateGoalPage'

// app
import AppPage from 'components/app-page/AppPage'

// auth
import LoginPage from 'components/auth/login/LoginPage'
import SignupPage from 'components/auth/signup/SignupPage'
import ForgotPasswordPage from 'components/auth/forgotPassword/ForgotPasswordPage'

// privacy center
import ConsentsPage from 'components/privacy_center/consents'
import ManagePage from 'components/privacy_center/manage/ManagePage'
import ManageMobile from 'components/privacy_center/manage/ManageMobile'
import HelpPage from 'components/privacy_center/help/HelpPage'
import HelpPageMobile from 'components/privacy_center/help/HelpMobile'
import AgeGatePage from 'components/privacy_center/age-gate/AgeGatePage'
import AgeGateMobile from 'components/privacy_center/age-gate/AgeGateMobile'
import DeclinePage from 'components/privacy_center/decline/DeclinePage'
import DeclineMobile from 'components/privacy_center/decline/DeclineMobile'
import ConsentsEditPage from 'components/privacy_center/consents-edit/ConsentsEditPage'
import ConsentsEditMobile from 'components/privacy_center/consents-edit/ConsentsEditMobile'

// layouts
import DefaultLayout from 'components/layout/DefaultLayout'
import PrivacyLayout from 'components/layout/PrivacyCenterLayout'
import WideLayout from 'components/layout/WideLayout'
import AuthLayout from 'components/layout/AuthLayout'
import PremiumLayout from 'components/layout/PremiumLayout'
import UACFLayout from 'components/layout/UACFLayout'

// migrate
import Migrate from 'components/migration/Migrate'
import MigrateConfirmed from 'components/migration/MigrateConfirmed'

// Samsung Gear Connect
import SamsungGearConnect from 'components/samsung_gear_connect/samsung_gear_connect'

// Year In Review
import YearInReviewLayout from 'components/layout/YearInReviewLayout'
import YearInReview2017 from 'components/yearInReview/2017/YearInReview'
import MidYearInReview2018 from 'components/yearInReview/2018/midyear'

// deletion
import DeletionPage from 'components/deletion/DeletionPage'
import DeletionMobile from 'components/deletion/DeletionMobile'

export default (
  <Route>
    <Route path='/' component={WideLayout}>
      <IndexRoute component={Landing} />
    </Route>
    <Route component={DefaultLayout}>
      {/* Not nesting these to better control active classes */}
      <Route path='my_home' component={ActivityFeed} />
      <Route path='my_home/dashboard'component={Dashboard} />
    </Route>

    <Route path='/auth'>
      <Route component={AuthLayout}>
        <Route path='login' component={LoginPage} />
        <Route path='signup' component={SignupPage} />
        <Route path='forgot_password' component={ForgotPasswordPage} />
      </Route>
      <Route component={UACFLayout}>
        <Route path='login/uacf' component={LoginPage} />
        <Route path='signup/uacf' component={SignupPage} />
        <Route path='forgot_password/uacf' component={ForgotPasswordPage} />
      </Route>
    </Route>

    <Route path='/privacy_center'>
      <Route component={DefaultLayout}>
        <Route path='manage' component={ManagePage} />
        <Route path='consents/decline' component={DeclinePage} />
        <Route path='consents/edit' component={ConsentsEditPage} />
      </Route>

      <Route component={PrivacyLayout}>
        <Route path='help' component={HelpPage} />
        <Route path='ineligible' component={AgeGatePage} />
        <Route path='consents' component={ConsentsPage} />
      </Route>
    </Route>

    <Route path='/mobile/privacy_center'>
      <Route path='manage' component={ManageMobile} />
      <Route path='help' component={HelpPageMobile} />
      <Route path='ineligible' component={AgeGateMobile} />
      <Route path='consents/decline' component={DeclineMobile} />
      <Route path='consents/edit' component={ConsentsEditMobile} />
    </Route>

    <Route path='/premium' component={PremiumLayout} onEnter={requireAuth}>
      <IndexRedirect to='membership' />
      <Route path='checkout' component={CheckoutPage} />
      <Route path='coupon' component={CouponPage} />
      <Route path='receipt/:id' component={ReceiptPage} />
      <Route path='membership' component={SubscriptionSettings} />
    </Route>

    <Route path='/workouts' component={DefaultLayout} onEnter={requireAuth} adUnitPaths={['Workouts']}>
      <Route path='dashboard'>
        <Route path='lifetime' component={LifetimeStatsPage} />
      </Route>
    </Route>

    <Route path='/workout' component={DefaultLayout} onEnter={requireAuth} adUnitPaths={['Workouts']}>
      <Route path='create' component={LogWorkoutPage} />
      <Route path='copy/:workoutId' component={CopyWorkoutPage} />
      <Route path='edit/:workoutId' component={EditWorkoutPage} />
    </Route>

    <Route path='/people' component={DefaultLayout} adUnitPaths={['Groups']}>
      <Route path='friends' onEnter={requireAuth} component={MyFriends} />
      <Route path='friends/find' onEnter={requireAuth} component={FindFriends} />
      <Route path='friends/invite' onEnter={requireAuth} component={InviteFriends} />
    </Route>

    <Route path='/mobile/china/migrate/user/confirm/:token' component={MigrateConfirmed} />
    <Route path='/mobile/china/migrate/user/:chinaUserId/:username' component={Migrate} />

    <Route path='/mobile/samsung_gear_connect/:stashedid' component={SamsungGearConnect} />

    <Route path='account' component={PrivacyLayout}>
      <Route path='delete' component={DeletionPage} />
    </Route>

    <Route path='/mobile/account/delete' component={DeletionMobile} />

    <Route path='/routes/print/:routeId' component={RoutePrintPage} onEnter={requirePremium} />

    <Route path='/routes' component={DefaultLayout} adUnitPaths={['Maps_Routes']}>
      <IndexRoute component={RouteSearchPage} />
      <Route path='search' component={RouteSearchPage} />
      {/* Not nesting these to better control active classes */}
      <Route onEnter={requireAuth} path='my_routes' component={MyRoutesPage} />
      <Route onEnter={requireAuth} path='my_routes/bookmarks'component={MyBookmarksPage} />
      <Route onEnter={requireAuth} path='my_routes/courses'component={MyCoursesPage} />
    </Route>

    <Route path='/app' component={WideLayout}>
      <IndexRoute component={AppPage} />
    </Route>

    <Route path='/profile/:userId' component={DefaultLayout} onEnter={requireAuth} adUnitPaths={['Goals']}>
      <Route path='goals' component={PersonalGoalsPage} />
      <Route path='goals/create' component={CreateGoalPage} />
    </Route>

    <Route path='/year-in-review' component={YearInReviewLayout}>
      <Route component={YearInReviewLayout}>
        <Route path='2017' component={YearInReview2017} />
      </Route>
      <Route component={WideLayout}>
        <Route path='mid-2018' component={MidYearInReview2018} />
      </Route>
    </Route>

    <Route component={DefaultLayout}>
      <Route path='/*' component={NotFoundPage} />
    </Route>

  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.jsx